import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { fetchReviewQueue, decideReview, type ReviewItem } from '@/services/siteApi';

// Admin: uploads the site scan held (docs/SCOPE_site_hosting.md §12). Download the zip, look, decide.
const SiteReviewPage: React.FC = () => {
  const [items, setItems] = useState<ReviewItem[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const load = () => fetchReviewQueue().then((d) => setItems(d.items)).catch((e) => setErr(e.message));
  useEffect(() => { load(); }, []);
  return (
    <main className="mx-auto" style={{ maxWidth: 760, padding: '24px 16px 96px', background: 'var(--hj-bg)', color: 'var(--hj-ink)', minHeight: 'calc(100vh - 68px)' }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, margin: '0 0 8px' }}>Site uploads held for review</h1>
      <p style={{ margin: '0 0 16px', fontSize: 14 }}><Link to="/admin/sites" style={{ color: 'var(--hj-ink)', textDecoration: 'underline' }}>All sites and usage</Link></p>
      {err && <p style={{ color: 'var(--hj-pink-ink)' }}>{err}</p>}
      {!items && !err && <Loader2 className="w-5 h-5 animate-spin" />}
      {items && items.length === 0 && <p>Nothing waiting.</p>}
      {items?.map((it) => (
        <div key={it.versionId} style={{ border: '1px solid var(--hj-hairline)', borderRadius: 'var(--hj-r-md)', padding: 16, marginBottom: 12, background: 'var(--hj-surface-1)' }}>
          <p style={{ margin: '0 0 6px', fontWeight: 600 }}>{it.handle}.heyjoesites.com · {it.ownerEmail}</p>
          <p style={{ margin: '0 0 8px', fontSize: 13, color: 'var(--hj-ink-2)' }}>{new Date(it.uploadedAt).toLocaleString()} · {it.fileCount} files</p>
          <ul style={{ margin: '0 0 12px', paddingLeft: 18, fontSize: 14 }}>
            {it.flags.map((f, i) => <li key={i}>{f.why} <code style={{ fontSize: 12 }}>{f.file}</code></li>)}
          </ul>
          <div className="flex flex-wrap gap-2">
            <Button asChild variant="outline" size="sm"><a href={it.filesUrl}>Download zip</a></Button>
            <Button size="sm" onClick={async () => { await decideReview(it.versionId, 'approve'); load(); }}>Approve</Button>
            <Button variant="destructive" size="sm" onClick={async () => {
              const reason = window.prompt('Reason the actor will see:', "This upload can't be hosted on Hey Joe Sites.") || undefined;
              await decideReview(it.versionId, 'reject', reason); load();
            }}>Reject</Button>
          </div>
        </div>
      ))}
    </main>
  );
};

export default SiteReviewPage;
